<div class="copy-wrapper">
    <span class="mb-2">&copy; copyright PZ Stelmach {{ currentYear }}</span>
    <span>{{ 'FOOTER.copy' | translate }}: <a href="https://codelabs.rocks/">codelabs.rocks</a></span>
</div>
